export default "__VITE_PUBLIC_ASSET__cef9a0e8__"